import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { StyledLink } from './style';

const Link = React.forwardRef(
  (
    { color = 'inherit', component: Component = RouterLink, children, listOfComp, ...rest },
    ref
  ) => {
    return (
      <StyledLink as={Component} color={color} ref={ref} {...rest}>
        {children}
      </StyledLink>
    );
  }
);

Link.displayName = 'Link';

Link.propTypes = {
  color: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.object]),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.object, PropTypes.string]),
  listOfComp: PropTypes.any // keep type safety but don't forward it
};

export default Link;
